import React, { useEffect, useState } from "react";

// Import CSS
import "./InvoicesPendingTable.scss";
import PaymentModal from "../../PaymentModal";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { listTenantInvoices } from "../../../../redux/slices/sliceActions";

const InvoicePendingTable = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.landlordslice);

  const [invoicesReceived, setInvoicesReceived] = useState([]);
  const [invoices, setInvoices] = useState([]);
  useEffect(() => {
    console.log(user);
    const details = {
      user_id: user?.data?.user?.user_id,
      token: user?.accessToken,
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
    };
    dispatch(listTenantInvoices({ details })).then((res) => {
      console.log("fetching update", res);
      setInvoicesReceived(res.payload.data?.invoices);
    });
  }, [user]);

  useEffect(() => {
    if (invoicesReceived.length > 0) {
      setInvoices(transformInvoices(invoicesReceived));
      console.log("Invoices:", invoices);
    }
  }, [invoicesReceived]);

  const [expandedInvoiceId, setExpandedInvoiceId] = useState(null);
  const [visibleInvoicesCount, setVisibleInvoicesCount] = useState(3); // Initially show 3 invoices

  const toggleExpand = (invoiceId) => {
    setExpandedInvoiceId(expandedInvoiceId === invoiceId ? null : invoiceId);
  };

  const showMoreInvoices = () => {
    setVisibleInvoicesCount((prevCount) => prevCount + 3);
  };

  const hideAllInvoices = () => {
    setVisibleInvoicesCount(3);
  };

  //modal
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
  };

  const [defaultValues, setDefaultValues] = useState({});
  useEffect(() => {
    //check if default values are set
    if (Object.keys(defaultValues).length > 0) {
      console.log("Default values:", defaultValues);
      setIsOpen(true); // Open the modal
    }
  }, [defaultValues]);

  const handlePayment = (invoiceId) => {
    // Handle the payment logic here
    setDefaultValues({}); // Clear the default values
    //function to find the invoice
    const invoice = invoices.find((invoice) => invoice?.id === invoiceId);
    //set the default values
    setDefaultValues({
      rent: invoice?.rent?.toString() || "0",
      water: invoice?.water?.toString() || "0",
      arrears: invoice?.arrears?.toString() || "0",
      serviceCharge: invoice?.serviceCharge?.toString() || "0",
      unpaidDeposit: invoice?.unpaidDeposit?.toString() || "0",
      garbage: invoice?.garbage?.toString() || 0,
      paymentMethod: "PAYBILL",
      month: invoice?.month,
      year: invoice?.year,
    });
    console.log(`Payment for invoice ${invoiceId}`);
  };
  return (
    <div className="invoices-pending-container">
      <table className="invoice-pending-table">
        <thead>
          <tr>
            <th>Invoice ID</th>
            <th>Status</th>
            <th>Due Date</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {invoices.slice(0, visibleInvoicesCount).map((invoice) => (
            <React.Fragment key={invoice?.id}>
              <tr
                onClick={() => toggleExpand(invoice?.id)}
                className="table-row"
              >
                <td>{invoice?.id}</td>
                <td>{invoice?.status}</td>
                <td>{invoice?.dueDate}</td>
                <td>{invoice?.totalAmount}</td>
              </tr>
              {expandedInvoiceId === invoice?.id && (
                <tr>
                  <td colSpan="4">
                    <div className="expanded-space">
                      <div>
                        <div className="title">Invoice Details</div>
                        <div className="expanded-data">
                          <div className="head">Invoice ID:</div>
                          <div className="details">{invoice?.id}</div>
                        </div>
                        <div className="expanded-data">
                          <div className="head">Rent:</div>
                          <div className="details">{invoice?.rent}</div>
                        </div>
                        <div className="expanded-data">
                          <div className="head">Unpaid Deposit:</div>
                          <div className="details">
                            {invoice?.unpaidDeposit}
                          </div>
                        </div>
                        <div className="expanded-data">
                          <div className="head">Water:</div>
                          <div className="details">{invoice?.water}</div>
                        </div>
                        <div className="expanded-data">
                          <div className="head">Garbage:</div>
                          <div className="details">{invoice?.garbage}</div>
                        </div>

                        <div className="expanded-data">
                          <div className="head">Other Charges:</div>
                          <div className="details">{invoice?.otherCharges}</div>
                        </div>
                        <div className={`expanded-data final`}>
                          <div className="head">Total Payable Amount:</div>
                          <div className="total">{invoice?.totalPayable}</div>
                        </div>
                        <button
                          className="make-payment-button"
                          onClick={() => handlePayment(invoice?.id)}
                        >
                          Make Payment
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className="buttons-container">
        {visibleInvoicesCount < invoices.length && (
          <button
            onClick={showMoreInvoices}
            className="show-more-and-hide-button"
          >
            Show More
          </button>
        )}
        {visibleInvoicesCount > 3 && (
          <button
            onClick={hideAllInvoices}
            className="show-more-and-hide-button"
          >
            Hide All
          </button>
        )}
      </div>

      <PaymentModal
        isOpen={isOpen}
        closeModal={closeModal}
        defaultValues={defaultValues} // Set default values here
        fieldsToShow={[
          "rent",
          "arrears",
          "water",
          "serviceCharge",
          "unpaidDeposit",
          "garbage",
        ]} // Specify which fields to show
      />
    </div>
  );
};
function transformInvoices(invoices) {
  console.log("received these invoices", invoices);

  return invoices
    .filter((invoice) => invoice?.payment_status !== "fully_paid") // Filter out fully paid invoices
    .sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at))
    .map((invoice) => {
      // Calculate the total amount by summing up the individual charges
      const totalAmount = (
        parseFloat(invoice?.rent || 0) +
        parseFloat(invoice?.water || 0) +
        parseFloat(invoice?.garbage || 0) +
        parseFloat(invoice?.service_charge || 0) +
        parseFloat(invoice?.late_fee || 0) +
        parseFloat(invoice?.arrears || 0)
      ).toFixed(2); // Ensure it's a number with two decimal places

      // Determine the status
      const status =
        invoice?.payment_status === "fully_paid" ? "Paid" : "Unpaid";

      // Calculate total payable amount
      const totalPayable = totalAmount; // Adjust if you need to add any extra charges

      return {
        id: `INV${(invoice?.invoice_id || "").slice(-3).padStart(3, "0")}`,
        status: invoice?.status === "pending" ? "Unpaid" : "Paid",
        dueDate: invoice?.due_date
          ? new Date(invoice?.due_date).toISOString().split("T")[0]
          : "no due date", // Return "no due date" if due_date is null or undefined
        totalAmount: invoice?.total_invoiced || "0",
        rent: invoice?.remaining_rent || "0",
        water: invoice?.remaining_water || "0",
        garbage: invoice?.remaining_garbage || "0",
        month: invoice?.month,
        year: invoice?.year,
        otherCharges: (
          parseFloat(invoice?.remaining_service_charge || 0) +
          parseFloat(invoice?.remaining_late_fee || 0) +
          parseFloat(invoice?.remaining_arrears || 0)
        ).toFixed(2),
        totalPayable: invoice?.remaining_balance || "0",
        serviceCharge: invoice?.remaining_service_charge || "0",
        arrears: invoice?.remaining_arrears || "0",
        unpaidDeposit: invoice?.remaining_unpaid_deposit || "0",
      };
    });
}

export default InvoicePendingTable;
